import {ResearchLitElement, html, css} from '@core/research-lit-element';

export class ResearchPaginationSkeleton extends ResearchLitElement {
    static get is() {
        return 'research-pagination-skeleton';
    }
    static get styles() {
        return css`
            :host {
                display: flex;
                flex-direction: column;
                width: 100%;
                --opacity: 0.1;
                background-color: var(--color-invert-background-solid-10);
            }

            .container {
                display: flex;
                justify-content: center;
                align-items: center;
                gap: var(--space-8);
            }

            .item {
                display: flex;
                height: 32px;
                width: 32px;
                background-color: var(--color-invert-component-tr-70);
                border-radius: var(--border-radius-circle);
            }
        `;
    }

    render() {
        return html`
            <div class="container">
                <div class="item"></div>
                <div class="item"></div>
                <div class="item"></div>
            </div>
        `;
    }
}
customElements.define(ResearchPaginationSkeleton.is, ResearchPaginationSkeleton);
